/**
 * Moduł do prezentacji popupa z ofertą leasingową w eKatalgu
 * na Listingu i Karcie Produktu
 */
app.service('wcLeasingCalculation', function (loading, modal, pageConfig) {
	function init() {
		$('body').on('click', '.js-wc-calculate-leasing', function () {
			var plu = $(this).data('plu');
			var shopCode = pageConfig.getData('wc').shopCode;
			loading.start();
			$.get('/leasing-calculation.ltr', {
				plu: plu,
				wcShopCode: shopCode
			})
				.done(function (html) {
					loading.stop();
					modal.generate({
						content: html,
						header: false,
						id: 'leasing-calculation-modal'
					});
				})
				.fail(function () {
					loading.stop();
					modal.alert('Nie udało się pobrać kalkulacji leasingowej. Spróbuj ponownie.');
				});
		});
	}

	return {
		init: init
	};
});